module.exports = __webpack_public_path__ + "img/CM-NL-CA-Mitsubishi-Lifestyle.1b551971.png";